import Styles from './styles.module.css';
import React from 'react';
import { FaRegLightbulb } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";

type Hint = {
  contents: any;
  setHintText: (value: any) => void;
};

const Hint: React.FC<Hint> = ({ contents, setHintText }) => {

  return (
    <>
    <div className={Styles.modal}>
      <div className={Styles.background_black}></div>
      <div className={Styles.contents}>

        <div className={Styles.modal_title}>
          <div>
            <FaRegLightbulb className={Styles.modal_hint} />
            <h4>{contents.title}</h4>
          </div>
          <RxCross2 className={Styles.modal_cross} onClick={() => setHintText({ title: "", desc: ""})} />
        </div>

        <p className={Styles.desc} dangerouslySetInnerHTML={{ __html: contents.desc }}></p>

      </div>
    </div>
    </>
  );
}

export default Hint;

